import {
    CLEAR_ERRORS,
    LOADING_UI,
    SET_DATA,
    SET_AUTH,
    SET_NEW_PROJECT,
    SET_ERRORS,
    SET_VERIFICATION_DOCUMENT,
    SET_COVER_IMAGE,
    SET_PROFILE_IMAGE,
} from "../types";
import axios from "axios";
import Cookie from "js-cookie";

//https://one-click-api.herokuapp.com

export const signup = (data, history) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .post("https://one-click-api.herokuapp.com/api/auth/signup", data)
        .then((res) => {
            dispatch({ type: CLEAR_ERRORS });
            dispatch({
                type: SET_DATA,
                payload: { userData: res.data },
            });
            console.log("User Created");
            return res.data;
        })
        .then((data) => {
            history.push("/signup/document");
            return data;
        })
        .then((userData) => {
            const data = {
                id: userData._id,
            };
            axios
                .post(
                    "https://one-click-api.herokuapp.com/api/user/sendVerificationEmail",
                    data
                )
                .catch((err) => {
                    console.error(err);
                });
        })
        .catch((err) => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data.error,
            });
        });
};

export const verifyEmail = (data, setSuccess) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    console.log(data);
    axios
        .get(`https://one-click-api.herokuapp.com/api/user/verifyEmail/${data}`)
        .then((data) => {
            dispatch({ type: CLEAR_ERRORS });
            setSuccess(true);
        })
        .catch((err) => {
            dispatch({
                type: SET_ERRORS,
                payload: { message: err.response.data.message },
            });
            setSuccess(false);
        });
};

export const resendVerificationEmail = (data) => (dispatch) => {
    axios
        .post(
            "https://one-click-api.herokuapp.com/api/user/sendVerificationEmail",
            data
        )
        .catch((err) => {
            console.log(err);
        });
};

export const login = (data, history) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .post("https://one-click-api.herokuapp.com/api/auth/login", data)
        .then((res) => {
            dispatch({ type: CLEAR_ERRORS });
            dispatch({
                type: SET_AUTH,
                payload: {
                    token: res.data.access_token,
                    user: res.data.user,
                },
            });
            console.log("Data Fetch Complete");
            return res.data;
        })
        .then(async (data) => {
            Cookie.set("refreshToken", data.refresh_token, {
                path: "/",
                expires: 7,
            });
            localStorage.setItem("firstLogin", true);
        })
        .then(() => {
            history.push("/dashboard/settings");
            window.location.reload();
        })
        .catch((err) => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data.error,
            });
        });
};

export const settingsUpdate = (data, history) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .post(
            "https://one-click-api.herokuapp.com/api/user/settingsUpdate",
            data
        )
        .then((res) => {
            dispatch({ type: CLEAR_ERRORS });
            dispatch({
                type: SET_DATA,
                payload: { userData: res.data },
            });
            console.log("Data Fetch Complete");
        })
        .then(() => {
            history.push("/dashboard/profile");
        })
        .catch((err) => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data,
            });
        });
};

export const setAuthenticated = () => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .get("https://one-click-api.herokuapp.com/api/auth/accessToken", {
            params: {
                refreshToken: Cookie.get("refreshToken"),
            },
        })
        .then((res) => {
            if (res.err) {
                dispatch({ type: CLEAR_ERRORS });
                return localStorage.removeItem("firstLogin");
            }
            dispatch({
                type: SET_AUTH,
                payload: {
                    token: res.data.access_token,
                    user: res.data.user,
                },
            });
        })
        .catch((err) => {
            // if (err.response.data.err === "Please login now!") {}
            dispatch({ type: CLEAR_ERRORS });
            console.error(err);
        });
};

export const createProject = (data, newProjectState) => (dispatch) => {
    dispatch({ type: LOADING_UI });
    axios
        .post(
            "https://one-click-api.herokuapp.com/api/projects/createProject",
            data
        )
        .then((res) => {
            dispatch({ type: CLEAR_ERRORS });
            dispatch({
                type: SET_NEW_PROJECT,
                payload: { project: res.data },
            });
            console.log("Project Created Successfully");
        })
        .then(() => newProjectState())
        .catch((err) => {
            console.error(err);
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data,
            });
        });
};

export const verificationDocument =
    (formData, userId, setProgress) => (dispatch) => {
        dispatch({ type: LOADING_UI });
        //60f3c032b53de71c8c7f9aba
        axios
            .post(
                `https://one-click-api.herokuapp.com/api/user/collegeIdVerification/${userId}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (data) => {
                        //Set the progress value to show the progress bar
                        console.log(
                            Math.round((100 * data.loaded) / data.total)
                        );
                        if (
                            Math.round((100 * data.loaded) / data.total) <= 90
                        ) {
                            setProgress(
                                Math.round((100 * data.loaded) / data.total)
                            );
                        }
                        setProgress(50);
                    },
                }
            )
            .then((res) => {
                console.log(res);
                setProgress(100);
                dispatch({ type: CLEAR_ERRORS });
                dispatch({
                    type: SET_VERIFICATION_DOCUMENT,
                    payload: { data: res.data.data },
                });
            })
            .catch((err) => {
                setProgress("");
                dispatch({
                    type: SET_ERRORS,
                    payload: err.response.data,
                });
            });
    };

export const profileImageUpload = (formData, userId) => (dispatch) => {
    console.log(formData);
    dispatch({ type: LOADING_UI });
    axios
        .post(
            `https://one-click-api.herokuapp.com/api/user/uploadProfileImage/${userId}`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        )
        .then((res) => {
            console.log(res);
            dispatch({ type: CLEAR_ERRORS });
            dispatch({
                type: SET_PROFILE_IMAGE,
                payload: { data: res.data.data },
            });
        })
        .catch((err) => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data,
            });
        });
};

export const coverImageUpload = (formData, userId) => (dispatch) => {
    console.log(formData);
    dispatch({ type: LOADING_UI });
    axios
        .post(
            `https://one-click-api.herokuapp.com/api/user/uploadCoverImage/${userId}`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        )
        .then((res) => {
            console.log(res);
            dispatch({ type: CLEAR_ERRORS });
            dispatch({
                type: SET_COVER_IMAGE,
                payload: { data: res.data.data },
            });
        })
        .catch((err) => {
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data,
            });
        });
};

// Creating axios default headers
// const token = localStorage.FBIdToken;
// if (token) {
//   const decodedToken = jwtDecode(token);
//   if (decodedToken.exp * 1000 < Date.now()) {
//     store.dispatch(logoutUser());
//     window.location.href = "/login";
//   } else {
//     store.dispatch({ type: SET_AUTHENTICATED });
//     axios.defaults.headers.common["Authorization"] = token;
//     store.dispatch(getUserData());
//   }
// }

// Deleting Axios default headers
//  localStorage.removeItem("FBIdToken");
//  delete axios.defaults.headers.common["Authorization"];
